import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  buttons: {
    width: "100%",
  },
}));

export default styles;
